import { ReactElement, ReactNode } from 'react'
import { ExpandMore } from '@mui/icons-material'
import { Box, IconButton, LinearProgress, Tooltip } from '@mui/material'
import Drawer from '@mui/material/Drawer'

interface Props {
  children?: ReactNode
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  expanded: boolean
  setIsDrawerExpanded: (expanded: boolean) => void
  sideDrawerExpanded: boolean
  isLoading?: boolean
  leftOffsetPx?: number
}

const BottomDrawer = ({
  children,
  isOpen,
  expanded,
  setIsDrawerExpanded,
  isLoading,
  leftOffsetPx = 0,
}: Props): ReactElement => {
  if (!isOpen) return <></>

  return (
    <Drawer
      anchor={'bottom'}
      open={true}
      variant={'persistent'}
      sx={({ distances }) => ({
        position: 'absolute',
        left: leftOffsetPx,
        right: 0,
        bottom: 0,
        flex: '0 0 auto',
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          position: 'absolute',
          width: leftOffsetPx > 0 ? `calc(100% - ${leftOffsetPx}px)` : '100%',
          left: leftOffsetPx,
          right: 0,
          bottom: 0,
          top: 'auto',
          height: expanded ? distances.bottomDrawerHeightExpanded : distances.bottomDrawerHeight,
          maxHeight: `60vh`,
          overflow: 'visible',
        },
      })}
    >
      {isLoading && (
        <Box>
          <LinearProgress />
        </Box>
      )}
      <Tooltip title="Expand" placement="top" enterDelay={500}>
        <IconButton
          aria-label="expand-bottom-drawer"
          size="medium"
          sx={theme => ({
            position: 'absolute',
            left: 'calc(100%/2)',
            top: -12,
            zIndex: 100000,
            transform: expanded ? '' : 'rotate(-180deg)',
            backgroundColor: '#ffffff',
            borderWidth: 1,
            borderColor: theme.palette.grey[300],
            borderStyle: 'solid',
            padding: 0,
            minHeight: 0,
            minWidth: 0,
            '&:hover': {
              backgroundColor: '#fff',
              color: '#3c52b2',
            },
          })}
          onClick={() => setIsDrawerExpanded(!expanded)}
          data-cy="expand-bottom-drawer-button"
        >
          <ExpandMore fontSize="inherit" />
        </IconButton>
      </Tooltip>
      {children}
    </Drawer>
  )
}
export default BottomDrawer
